import { BgColorType, useScreenWidth } from "@/lib/main";
import { CSSProperties, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  bgColor?: BgColorType;
  breakpoint?: number;
  showTabBarMenu?: boolean;
}>;

export default function Footer({
  children,
  bgColor,
  breakpoint,
  showTabBarMenu,
}: Props) {
  const { screenWidth } = useScreenWidth();

  const styles: CSSProperties = {
    position: "relative",
    zIndex: "var(--z-index-footer)",

    backgroundColor: bgColor
      ? `var(--color-background-${bgColor})`
      : "var(--color-background-footer)",
    boxShadow: "inset var(--box-shadow-color) var(--box-shadow-offset)",

    maxWidth: "100%",

    padding:
      breakpoint && showTabBarMenu && screenWidth < breakpoint
        ? 0
        : "var(--spacing-3xl) var(--page-padding-horizontal)",
    // adds margin for TabBarMenu if it's present
    marginTop:
      breakpoint && showTabBarMenu && screenWidth < breakpoint
        ? "var(--tabbar-height)"
        : 0,
  };

  return <footer style={styles}>{children}</footer>;
}
